import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APIModalitaFatturazione {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  async initDDL(user) {

    let formData = new FormData();

    formData.append("username", user);

    return axios.post(this.getUrlDomain("EmtAgilaCtrlsInitDDLApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getValuesPratica(user, idpratica) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id_pratica", idpratica);

    return axios.post(this.getUrlDomain("EmtAgilaGetValuesPraticaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  async getInfoAzienda(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("v_id", id);

    return axios.post(this.getUrlDomain("EmtAgilaSediOpGetInfoAzApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async saveSedeOperativa(sede_operativa, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in sede_operativa) {
      formData.append(key, sede_operativa[key]);
    }

    return axios.post(this.getUrlDomain("EmtAgilaSaveSediOpApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async editFattura(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);


    return axios.post(this.getUrlDomain("EmtAgilaEditFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async editFattura(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);


  //   return axios.post(this.getUrlDomain("goEditFatturaModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async deleteFatture(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);


    return axios.post(this.getUrlDomain("EmtAgilaDeleteFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  // async deleteFatture(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);


  //   return axios.post(this.getUrlDomain("goDeleteFatturaModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }






  async insertFattura(controllo, user) {

    let formData = new FormData();

    formData.append("username", user);

    for (var key in controllo) {
      formData.append(key, controllo[key]);
    }

    return axios.post(this.getUrlDomain("EmtAgilaInsertFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  // async insertFattura(controllo, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);

  //   for (var key in controllo) {
  //     formData.append(key, controllo[key]);
  //   }

  //   return axios.post(this.getUrlDomain("goInsertFatturaModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }




  async updateFattura(controllo, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in controllo) {
      formData.append(key, controllo[key]);
    }

    return axios.post(this.getUrlDomain("EmtAgilaUpdateFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  // async updateFattura(controllo, user, id) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);

  //   for (var key in controllo) {
  //     formData.append(key, controllo[key]);
  //   }

  //   return axios.post(this.getUrlDomain("goUpdateFatturaModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }


  async deleteCondizioni(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    return axios.post(this.getUrlDomain("EmtAgilaDeleteCtrlsCondApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async exportXls(user, curSrcText, curCompany, curPrjType, curCtrType, curStatus) {

    let formData = new FormData();

    formData.append("username", user);

    formData.append("curSrcText", curSrcText);
    formData.append("curCompany", curCompany);
    formData.append("curPrjType", curPrjType);
    formData.append("curCtrType", curCtrType);
    formData.append("curStatus", curStatus);


    return axios.post(this.getUrlDomain("EmtAgilaExportXlsCtrlsApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  async getInfoPratica(user, idpratica) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("idpratica", idpratica);

    return axios.post(this.getUrlDomain("EmtAgilaCtrlsGetInfoPratApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async loadCtrsStd(idpratica, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("idp", idpratica);

    return axios.post(this.getUrlDomain("EmtAgilaCtrlsLoadStdValApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async chooseLoadDefControls(user, idpratica) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("idp", idpratica);

    return axios.post(this.getUrlDomain("EmtAgilaGetCtrlsPratApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }



  async validaCreaFatture(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);


    return axios.post(this.getUrlDomain("EmtAgilaCopyFatturaValidateApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async validaCreaFatture(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("id", id);


  //   return axios.post(this.getUrlDomain("goValidateCreateFattModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }


  async creaFatture(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);


    return axios.post(this.getUrlDomain("EmtAgilaCopyFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async creaFatture(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("id", id);


  //   return axios.post(this.getUrlDomain("goCreateFattModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }


  // async creaMultiFatture(id, user, importo) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("id", id);
  //   formData.append("importo", importo);

  //   return axios.post(this.getUrlDomain("goCreateFattModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  // }



  async creaMultiFatture(id, user, importo, rimanente) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);
    formData.append("importo", importo);
    formData.append("rimanente", rimanente);

    return axios.post(this.getUrlDomain("EmtAgilaCopyMultiFatturaApi"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getInfoFattura(id) {

    let formData = new FormData();

    formData.append("id", id);


    return axios.post(this.getUrlDomain("goGetInfoFatturaModalitaFatturazione"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  async getDefaultValueModFatt(id) {

    let formData = new FormData();

    formData.append("id", id);


    return axios.post(this.getUrlDomain("EmtGetDefaultValueModFatt"), formData, { 'Content-Type': 'multipart/form-data' });

  }

}

export default new APIModalitaFatturazione({
  url: "https://services.ebadge.it/public/api/"
})
